<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <p>
      {{ t("remove-ia-powered-targeting-popup.deletion_confirm") }}
    </p>
  </div>
  <div class="flex justify-end gap-2">
    <button iButton variant="ghost" (click)="modalRef.close()">
      {{ t("common.cancel") }}
    </button>
    <button iButton variant="destructive" (click)="delete()">
      {{ t("common.delete") }}
    </button>
  </div>
</ng-container>
